module.exports = __webpack_public_path__ + "img/espa-alt-2.b9bd7e95.jpg";